
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 133553"}},[_c('g',{attrs:{"fill":"none","stroke":"#4c535f","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5","data-name":"vuesax/twotone/setting-3"}},[_c('path',{attrs:{"d":"M7.657 17.27h4.437c3.7 0 5.177-1.479 5.177-5.177V7.656c0-3.698-1.479-5.177-5.177-5.177H7.657c-3.698 0-5.177 1.479-5.177 5.177v4.437c0 3.698 1.479 5.177 5.177 5.177z"}}),_c('g',{attrs:{"data-name":"Group 632","opacity":".4"}},[_c('path',{attrs:{"data-name":"Vector","d":"M12.516 14.681v-2.884M12.516 6.509V5.067M14.439 8.432a1.923 1.923 0 11-1.923-1.923 1.923 1.923 0 011.923 1.923zM7.236 14.681v-1.442M7.236 7.951V5.067M9.159 11.316a1.923 1.923 0 11-1.923-1.923 1.923 1.923 0 011.923 1.923z"}})])])])])
          )
        }
      }
    